<template>
  <o-modal :active="active" :canCancel="false" class="modal-sm" :class="{ 'is-clipped': isLoading }">
    <div class="modal-card">
      <header class="modal-card-head">
        <h4 class="modal-card-title">Clone Template</h4>
      </header>
      <section class="modal-card-body">
        <o-loading :active="isLoading" :full-page="false" :can-cancel="false"></o-loading>

        <div class="field">
          <label class="label">New Template Name</label>
          <div class="control">
            <input
              v-model.trim="cloneName"
              type="text"
              class="input"
              placeholder="Enter name (Required)"
              :disabled="isLoading"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">Number of Copies</label>
          <div class="copy-input-wrap">
            <input
              v-model.number="copies"
              type="number"
              min="1"
              max="5"
              class="input copies-input"
              :disabled="isLoading"
            />
            <span class="copy-note">(5 Max)</span>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot is-justify-content-flex-end">
        <button class="button is-outlined" type="button" :disabled="isLoading" @click="onClose">
          Cancel
        </button>
        <button class="button has-background-black-bis" type="button" :disabled="isCloneDisabled" @click="onClone">
          Clone
        </button>
      </footer>
    </div>
  </o-modal>
</template>

<script>
import { computed, ref, watch } from 'vue';

export default {
  name: 'CloneTemplate',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    templateName: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'confirm'],
  setup(props, { emit }) {
    const cloneName = ref('');
    const copies = ref(1);

    watch(
      () => props.active,
      (isActive) => {
        if (!isActive) return;
        cloneName.value = `${props.templateName || ''} - Clone`;
        copies.value = 1;
      },
      { immediate: true },
    );

    const isCloneDisabled = computed(() => {
      const isNameInvalid = !cloneName.value || cloneName.value.trim().length < 3;
      const isCopiesInvalid = !Number.isInteger(copies.value) || copies.value < 1 || copies.value > 5;
      return props.isLoading || isNameInvalid || isCopiesInvalid;
    });

    const onClose = () => {
      emit('close');
    };

    const onClone = () => {
      emit('confirm', {
        name: cloneName.value.trim(),
        copies: copies.value,
      });
    };

    return {
      cloneName,
      copies,
      isCloneDisabled,
      onClose,
      onClone,
    };
  },
};
</script>

<style scoped>
.copy-input-wrap {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.copies-input {
  max-width: 96px;
}

.copy-note {
  font-style: italic;
  color: #687684;
}
</style>
